import { type UserProfile } from '@/types';

export const appcuesSetup = (userProfile: UserProfile) => {
  if (typeof Appcues !== 'undefined') {
    const { company_schema_name, id, email, full_name } = userProfile;

    Appcues.identify(id, {
      company_schema_name,
      email,
      full_name,
    });
  }
};
